// extracted by mini-css-extract-plugin
module.exports = {"terms":"a10a3f92e9--terms--NZA8E","label":"a10a3f92e9--label--xiwmQ","indicator":"a10a3f92e9--indicator--kSM4u","rate":"a10a3f92e9--rate--nlozl"};